import Nullstack from 'nullstack';
export default function IconHeading({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-heading",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h10"
  }), "   ", Nullstack.element("path", {
    d: "M7 5v14"
  }), "   ", Nullstack.element("path", {
    d: "M17 5v14"
  }), "   ", Nullstack.element("path", {
    d: "M15 19h4"
  }), "   ", Nullstack.element("path", {
    d: "M15 5h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 19h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 5h4"
  }), " ");
}